import { Scenario } from '@scenario/models/scenario.model';
import { HistoricalDataMode } from '@scenario/enums/historical-data-mode.enum';

export const applyHistoricalDataMode = (scenarios: Scenario[], mode: HistoricalDataMode): Scenario[] => {
  switch (mode) {
    case HistoricalDataMode.FORECAST:
      return scenarios.map(scenario => ({
        ...scenario,
        historicalPricePerYear: {},
      }));

    case HistoricalDataMode.HISTORICAL:
      return scenarios.map(scenario => ({
        ...scenario,
        pricePerYear: {},
        historicalPricePerYear: scenario.historicalPricePerYear,
      }));

    case HistoricalDataMode.COMBINED:
      return scenarios;

    default:
      return scenarios;
  }
};


